export default __webpack_public_path__ + "static/placeholder-dark-b36928a7c0fe29b1f7cb09922ca60d6b.webp";